import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from '@mui/material';
import useStyles from './styles';
export function BigSuccessAlert(_ref) {
  let _ref$children = _ref.children,
    children = _ref$children === void 0 ? undefined : _ref$children,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? undefined : _ref$onClose;
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(Alert, {
    severity: "success",
    icon: false,
    onClose: onClose,
    className: "".concat(classes.bigAlert, " ").concat(onClose ? classes.alertWithClose : '')
  }, children);
}
export function BigWarningAlert(_ref2) {
  let _ref2$children = _ref2.children,
    children = _ref2$children === void 0 ? undefined : _ref2$children,
    _ref2$onClose = _ref2.onClose,
    onClose = _ref2$onClose === void 0 ? undefined : _ref2$onClose;
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(Alert, {
    severity: "warning",
    icon: false,
    onClose: onClose,
    className: "".concat(classes.bigAlert, " ").concat(onClose ? classes.alertWithClose : '')
  }, children);
}
export function BigInfoAlert(_ref3) {
  let _ref3$children = _ref3.children,
    children = _ref3$children === void 0 ? undefined : _ref3$children,
    _ref3$onClose = _ref3.onClose,
    onClose = _ref3$onClose === void 0 ? undefined : _ref3$onClose;
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(Alert, {
    severity: "info",
    icon: false,
    onClose: onClose,
    className: "".concat(classes.bigAlert, " ").concat(onClose ? classes.alertWithClose : '')
  }, children);
}
export function BigErrorAlert(_ref4) {
  let _ref4$children = _ref4.children,
    children = _ref4$children === void 0 ? undefined : _ref4$children,
    _ref4$onClose = _ref4.onClose,
    onClose = _ref4$onClose === void 0 ? undefined : _ref4$onClose;
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(Alert, {
    severity: "error",
    icon: false,
    onClose: onClose,
    className: "".concat(classes.bigAlert, " ").concat(onClose ? classes.alertWithClose : '')
  }, children);
}
export function BigBrandAlert(_ref5) {
  let _ref5$children = _ref5.children,
    children = _ref5$children === void 0 ? undefined : _ref5$children,
    _ref5$onClose = _ref5.onClose,
    onClose = _ref5$onClose === void 0 ? undefined : _ref5$onClose;
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(Alert, {
    variant: "brand",
    icon: false,
    onClose: onClose,
    className: "".concat(classes.bigAlert, " ").concat(onClose ? classes.alertWithClose : '')
  }, children);
}
BigSuccessAlert.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func
};
BigWarningAlert.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func
};
BigInfoAlert.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func
};
BigErrorAlert.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func
};
BigBrandAlert.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func
};